// Components/ChatContacts/components/SearchBar.jsx
import React from "react";
import { TextField, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

const SearchBar = ({ searchQuery, setSearchQuery }) => {
    return (
        <TextField
            label="Buscar contacto"
            variant="outlined"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <SearchIcon style={{ color: "#fff", marginRight: '-10px' }} />
                    </InputAdornment>
                ),
            }}
            sx={{
                borderRadius: '8px',
                marginTop: '10px',
                color: "#fff",
                '& .MuiInputLabel-root': {
                    color: '#fff',
                },
                '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                        borderColor: '#fff',
                    },
                    '&:hover fieldset': {
                        borderColor: '#76c7c0',
                    },
                    '&.Mui-focused fieldset': {
                        borderColor: '#76c7c0',
                    },
                },
                '& .MuiOutlinedInput-input': {
                    padding: '10px',
                    color: '#fff',
                },
            }}
        />
    );
};

export default SearchBar;